import * as Animate from "react-reveal";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "../../../components/svgs";

const steps = [
  {
    number: "01",
    tag: "TRAIN",
    title: "Train your talent",
    desc:
      "Build AI, technology, business and leadership capability through live, practical programmes designed around your organisation.",
    points: [
      "Capability diagnosis",
      "Custom academies",
      "Applied team projects",
    ],
    cta: "Explore workforce learning",
    to: "#competencies",
  },
  {
    number: "02",
    tag: "HIRE",
    title: "Hire great talent",
    desc:
      "Move from a clear role need to a focused shortlist of professionals with relevant skills evidence and human context.",
    points: [
      "Role-focused matching",
      "Verified capability evidence",
      "Focused shortlists",
    ],
    cta: "Explore UtivaHire",
    to: "/hire",
  },
  {
    number: "03",
    tag: "PAY",
    title: "Pay globally",
    desc:
      "Coordinate onboarding, contracts, multi-currency payments and ongoing support for employees and contractors across borders.",
    points: [
      "Cross-border onboarding",
      "Multi-currency payments",
      "Workforce operations",
    ],
    cta: "Explore UtivaPay",
    to: "/pay",
  },
];

const BusinessJourneySection = () => {
  return (
    <section
      className="py-16 md:py-20 lg:py-24 px-4"
      id="journey"
      style={{ background: "#fdf2df" }}
    >
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            One connected business journey
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start mb-12 lg:mb-14">
            <h2 className="lg:col-span-2 text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black max-w-2xl tracking-[-0.03em] text-primary">
              Start where your workforce needs support today.
            </h2>
            <p className="text-gray text-base font-poppins leading-relaxed lg:pt-2">
              Use one Utiva solution or connect all three as your team grows.
              Every path stays grounded in practical capability, relevant talent
              and clear workforce operations.
            </p>
          </div>
        </Animate.Fade>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-5">
          {steps.map((step) => (
            <Animate.Fade bottom key={step.number}>
              <article className="h-full flex flex-col rounded-2xl p-7 bg-white shadow-course-card">
                <div className="flex items-center justify-between mb-8">
                  <span
                    className="w-9 h-9 rounded-full grid place-items-center font-poppins text-sm font-extrabold text-primary"
                    style={{ background: "#e7e6fb" }}
                  >
                    {step.number}
                  </span>
                  <span className="text-[#8e5e00] font-poppins text-xs font-extrabold tracking-widest">
                    {step.tag}
                  </span>
                </div>
                <h3 className="font-poppins font-bold text-2xl text-primary mb-3">
                  {step.title}
                </h3>
                <p className="text-gray font-poppins text-sm leading-relaxed mb-5">
                  {step.desc}
                </p>
                <ul className="grid gap-2 mb-6">
                  {step.points.map((point) => (
                    <li
                      key={point}
                      className="flex items-center gap-2.5 text-default font-poppins text-sm"
                    >
                      <span className="text-secondary" aria-hidden="true">
                        ✓
                      </span>
                      {point}
                    </li>
                  ))}
                </ul>
                <Link
                  to={step.to}
                  className="mt-auto pt-5 border-t border-hire-line text-primary font-poppins font-extrabold text-sm flex items-center justify-between hover:text-secondary transition-colors"
                >
                  {step.cta}
                  <ArrowUpRight className="w-3.5 h-3.5" />
                </Link>
              </article>
            </Animate.Fade>
          ))}

          {[1, 2].map((position) => (
            <span
              key={position}
              className="hidden md:grid absolute z-10 top-1/2 -translate-y-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-secondary text-white place-items-center"
              style={{ left: `${position * (100 / 3)}%` }}
              aria-hidden="true"
            >
              →
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessJourneySection;
